<template>
    <div id="main">
        <div class="page">
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('rede') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('promotor') }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t('cadastros') }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'redes' })">{{
                                        $t('redes')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        !rede.idprorede ? $t('nova-rede') : title
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({
                                    name: 'pro-rede-list',
                                })
                            "
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                ((!isUpdate && permissao.create) ||
                                    (isUpdate && permissao.update)) &&
                                !redeIntegracao
                            "
                            class="save-btn"
                            type="button"
                            @click="salvar()"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit page-container">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="'codigo'"
                                ref="idproredeerpInput"
                                v-model="rede.idproredeerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                            />
                        </div>
                        <div class="column is-8">
                            <v-input
                                v-model="rede.descricao"
                                :id="'descricao'"
                                :placeholder="'descricao-da-rede-placeholder'"
                                :maxlength="50"
                                :title="'descricao-da-rede'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!rede.descricao"
                                ref="descricaoInput"
                                :required="true"
                            />
                        </div>
                        <div class="column is-2">
                            <vss-select
                                title="situacao"
                                :options="situacoes"
                                :mlLabels="true"
                                v-model="situacao"
                                :height="40"
                                :clearable="true"
                                :label="'label'"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RedeService from '@/services/promotor/RedeService';
import RedeValidation from '@/services/validations/RedeValidation';
import Message from '@/models/Message';

export default {
    data() {
        return {
            redeIntegracao: this.$store.state.user.tabelasERPWebServer.includes('PRO_REDE'),
            rede: {
                idproredeerp: '',
                descricao: '',
                situacao: 1,
            },
            editable: false,
            title: '',
            msgs: [],
            isSaving: false,
            situacao: { label: 'ativo', id: 1 },
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            isUpdate: false,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'redes');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'rede' },
            });
        } else {
            this.isUpdate = !!this.$route.params.id;
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'rede' },
                });
            }

            if (this.rede != null && this.rede != {}) {
                this.editable = true;
            }

            this.service = new RedeService(this.$http, this.$router);
            this.validation = new RedeValidation(this.msgs);

            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados(this.$route.params.id);
            }
        }
    },
    methods: {
        carregarDados(id) {
            this.service.find(id).then((body) => {
                if (body.content) {
                    this.rede = body.content;
                    this.title = this.rede.descricao;
                    this.situacao = this.situacoes[this.rede.situacao];
                } else {
                    this.$router.push({ name: 'pro-rede-new' });
                }
            });
        },
        mapItems(body) {
            let redelist = body.content.map((r) => {
                return {
                    id: r.idprorede,
                    descricao: r.descricao,
                    situacao: r.situacao,
                    excluir: 'excluir-rede',
                    _cellVariants: { excluir: 'col-medium' },
                };
            });
            return redelist;
        },
        zeraLatLong() {
            this.rede.latitude = 0;
            this.rede.longitude = 0;
        },
        salvar() {
            let rede = this.mapTosave(this.rede);
            this.rede.situacao = this.situacao.id;
            if (this.validation.validate(rede, this.$refs)) {
                this.isSaving = true;
                this.service
                    .save(rede)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-rede-salva';
                            if (this.rede.id) {
                                msg = 'msg-rede-edita';
                            }
                            this.rede = body.content;
                            this.msgs.push(new Message('success', msg, true));
                            if(!this.isUpdate) this.redirectToList()
                        } else {
                            if (this.$t(body.message)) {
                                this.msgs.push(new Message('alert', body.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                        this.isSaving = false;
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                        this.isSaving = false;
                    });
            }
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: 'pro-rede-list',
                });
            }, 1500);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    .page {
        position: relative;
    }
}
</style>
